import { render, staticRenderFns } from "./live-staging.vue?vue&type=template&id=ff36d522&scoped=true&"
import script from "./live-staging.vue?vue&type=script&lang=js&"
export * from "./live-staging.vue?vue&type=script&lang=js&"
import style0 from "./live-staging.vue?vue&type=style&index=0&id=ff36d522&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff36d522",
  null
  
)

export default component.exports